import _objectSpread from "@babel/runtime/helpers/esm/objectSpread2";
import _slicedToArray from "@babel/runtime/helpers/esm/slicedToArray";
import React, { useState, useEffect } from "react";
import { Formik, Form, Field } from "formik";
import * as Yup from "yup";
import moment from "moment";
import SendIcon from "@material-ui/icons/Send";
import { Button, Grid, SubmitButton, Dialog, makeStyles, DatePicker, Typography, Divider, Create, Chip, SearchSelect, numeral, setLocale, PdfViewer } from "../../../../";
import { Debug } from "../../../../Molecules/Forms/Debug";
import selects from "../../../../assets/selects";
var useStyles = makeStyles(function (theme) {
  return {
    root: {
      display: "flex",
      "flex-wrap": "wrap"
    },
    form: {
      "padding-top": "10px"
    },
    flex: {
      display: "flex",
      "justify-content": "space-between",
      "align-items": "baseline"
    },
    "flex-form": {
      "justify-content": "flex-start"
    },
    w40: {
      width: "40%"
    },
    w30: {
      width: "30%"
    },
    w20: {
      width: "20%"
    },
    mr15: {
      "margin-right": "15px"
    },
    actions: {
      display: "flex",
      padding: "30px",
      "justify-content": "flex-end"
    },
    p50: {
      padding: "30px 0px"
    },
    invoice: {
      "padding-bottom": "30px"
    }
  };
});

var DialogViewInvoice = function DialogViewInvoice(props) {
  // console.log("DialogViewInvoice props", props);
  var invoice = props.invoice,
      variant = props.variant,
      translation = props.translation,
      open = props.open,
      onClose = props.onClose,
      editStatus = props.editStatus,
      sendNotification = props.sendNotification,
      franchise = props.franchise,
      locale = props.locale,
      _props$historyView = props.historyView,
      historyView = _props$historyView === void 0 ? false : _props$historyView;
  var classes = useStyles();
  var title = "";
  useEffect(function () {
    if (locale) setLocale(locale);
    title = translation ? "".concat(translation.title, " ").concat(invoice && invoice.docnumber) : "Invoice ".concat(invoice && invoice.docnumber);
    invoice && setSelectedInvoice(invoice);
  }, [invoice]);
  useEffect(function () {
    if (locale) setLocale(locale);
  }, [locale]);

  var _useState = useState("view"),
      _useState2 = _slicedToArray(_useState, 2),
      modeStatus = _useState2[0],
      setStatusMode = _useState2[1];

  var _useState3 = useState(null),
      _useState4 = _slicedToArray(_useState3, 2),
      selectedInvoice = _useState4[0],
      setSelectedInvoice = _useState4[1];
  /* ----Edit */


  var handleEdit = function handleEdit() {
    return setStatusMode("edit");
  };

  var handleClose = function handleClose() {
    return setStatusMode("view");
  };
  /* Send Notification */


  var handleSendNotification = function handleSendNotification() {
    sendNotification(invoice._id);
    setSelectedInvoice(_objectSpread(_objectSpread({}, selectedInvoice), {}, {
      sent: true
    }));
  };

  return [/*#__PURE__*/React.createElement(Dialog, {
    fullWidth: true,
    maxWidth: "xl",
    title: title,
    open: open,
    onClose: onClose,
    mode: variant,
    key: 0
  }, /*#__PURE__*/React.createElement(Grid, {
    container: true,
    className: classes.root
  }, /*#__PURE__*/React.createElement(Grid, {
    item: true,
    md: !historyView ? 8 : 12
  }, selectedInvoice ? /*#__PURE__*/React.createElement(PdfViewer, {
    variant: "viewer",
    data: selectedInvoice,
    translation: translation ? translation.pdf.document : null
  }) : /*#__PURE__*/React.createElement(Typography, {
    variant: "body2"
  }, translation ? translation.pdf.message : "PDF file couldn't be generated. Please try again")), !historyView && /*#__PURE__*/React.createElement(Grid, {
    item: true,
    md: 4,
    className: classes.p50
  }, selectedInvoice && /*#__PURE__*/React.createElement(Grid, {
    item: true,
    md: 12,
    className: classes.invoice
  }, /*#__PURE__*/React.createElement("div", {
    className: classes.flex
  }, /*#__PURE__*/React.createElement(Typography, {
    variant: "subtitle1",
    color: "primary"
  }, translation ? translation.client : "Client: "), /*#__PURE__*/React.createElement(Typography, {
    variant: "subtitle1"
  }, selectedInvoice && selectedInvoice.type === "in" ? selectedInvoice.franchise.billingInfo.name : selectedInvoice.client.billingInfo.name)), /*#__PURE__*/React.createElement("div", {
    className: classes.flex
  }, /*#__PURE__*/React.createElement(Typography, {
    variant: "subtitle1",
    color: "primary"
  }, translation ? translation.date : "Date: "), /*#__PURE__*/React.createElement(Typography, {
    variant: "subtitle1"
  }, moment(selectedInvoice.date).format("DD/MM/YYYY"))), /*#__PURE__*/React.createElement("div", {
    className: classes.flex
  }, /*#__PURE__*/React.createElement(Typography, {
    variant: "subtitle1",
    color: "primary"
  }, translation ? translation.due_date : "Date: "), /*#__PURE__*/React.createElement(Typography, {
    variant: "subtitle1"
  }, moment(selectedInvoice.due_date).format("DD/MM/YYYY"))), selectedInvoice.status == "paid" && /*#__PURE__*/React.createElement("div", {
    className: classes.flex
  }, /*#__PURE__*/React.createElement(Typography, {
    variant: "subtitle1",
    color: "primary"
  }, translation ? translation.payment_date : "Date of payment: "), /*#__PURE__*/React.createElement(Typography, {
    variant: "subtitle1"
  }, moment(selectedInvoice.paid).format("DD/MM/YYYY"))), /*#__PURE__*/React.createElement("div", {
    className: classes.flex
  }, /*#__PURE__*/React.createElement(Typography, {
    variant: "subtitle1",
    color: "primary"
  }, translation ? translation.subtotal : "Subtotal: "), /*#__PURE__*/React.createElement(Typography, {
    variant: "subtitle1"
  }, numeral(selectedInvoice.subtotal).format("0,0[.]00 $"))), /*#__PURE__*/React.createElement("div", {
    className: classes.flex
  }, /*#__PURE__*/React.createElement(Typography, {
    variant: "subtitle1",
    color: "primary"
  }, translation ? translation.tax : "Tax: "), /*#__PURE__*/React.createElement(Typography, {
    variant: "subtitle1"
  }, numeral(selectedInvoice.tax).format("0,0[.]00 $"))), /*#__PURE__*/React.createElement("div", {
    className: classes.flex
  }, /*#__PURE__*/React.createElement(Typography, {
    variant: "subtitle1",
    color: "primary"
  }, translation ? translation.total : "Total "), /*#__PURE__*/React.createElement(Typography, {
    variant: "subtitle1"
  }, numeral(selectedInvoice.total).format("0,0[.]00 $")))), /*#__PURE__*/React.createElement(Divider, null), /*#__PURE__*/React.createElement(Grid, {
    item: true,
    md: 12,
    className: classes.p50
  }, /*#__PURE__*/React.createElement("div", {
    className: classes.flex
  }, /*#__PURE__*/React.createElement(Typography, {
    variant: "subtitle1",
    color: "primary"
  }, translation ? translation.status : "Status"), /*#__PURE__*/React.createElement("div", {
    className: classes.flex
  }, selectedInvoice && [/*#__PURE__*/React.createElement(Chip, {
    variant: "outlined",
    label: translation ? translation.selects.status.items.find(function (item) {
      return item.value === selectedInvoice.status;
    }).label : selects.invoice_status_labels[selectedInvoice.status],
    style: selectedInvoice.status === "pending" ? {
      borderRadius: "5px",
      background: "transparent",
      border: "1px solid #ffe082",
      color: "#ffe082"
    } : selectedInvoice.status === "paid" ? {
      borderRadius: "5px",
      border: "1px solid #77ffb5",
      color: "#77ffb5",
      background: "transparent"
    } : selectedInvoice.status === "payment_failed" || selectedInvoice.status === "overdue" ? {
      borderRadius: "5px",
      border: "1px solid #E95A58",
      color: "#fff",
      background: "transparent"
    } : selectedInvoice.status === "draft" ? {
      borderRadius: "5px",
      border: "1px solid #999",
      color: "#fff",
      background: "transparent"
    } : selectedInvoice.status === "amended" ? {
      borderRadius: "5px",
      border: "1px solid #28e2ab",
      color: "#28e2ab",
      background: "transparent"
    } : {
      borderRadius: "5px",
      border: "1px solid #80b9d6",
      color: "#80b9d6",
      background: "transparent"
    }
  })], selectedInvoice && selectedInvoice.status === "paid" && /*#__PURE__*/React.createElement(Typography, {
    variant: "subtitle1",
    style: {
      margin: "0px 15px"
    }
  }, moment(selectedInvoice.payment_date).format("DD/MM/YYYY")), modeStatus === "view" && variant !== "subscription-view" && /*#__PURE__*/React.createElement(Button, {
    "data-cy": "edit-info",
    className: classes.edit,
    color: "default",
    variant: "text",
    onClick: handleEdit
  }, /*#__PURE__*/React.createElement(Create, {
    style: {
      color: "#ffe082"
    }
  })))), selectedInvoice && modeStatus === "edit" && variant !== "subscription-view" && /*#__PURE__*/React.createElement(Formik, {
    initialValues: {
      status: selectedInvoice.status,
      payment_date: selectedInvoice.payment_date ? selectedInvoice.payment_date : moment()
    },
    onSubmit: function onSubmit(values, _ref) {
      var resetForm = _ref.resetForm;
      editStatus(_objectSpread(_objectSpread({}, values), {}, {
        id: selectedInvoice._id
      }));
      setSelectedInvoice(_objectSpread(_objectSpread({}, selectedInvoice), values));
      handleClose();
    },
    render: function render(_ref2) {
      var values = _ref2.values,
          isValid = _ref2.isValid,
          isSubmitting = _ref2.isSubmitting;
      return /*#__PURE__*/React.createElement(Form, {
        "data-cy": "edit-status",
        className: classes.form
      }, /*#__PURE__*/React.createElement(Grid, {
        item: true,
        md: 12,
        className: [classes.flex, classes["flex-form"]].join(" ")
      }, /*#__PURE__*/React.createElement(Field, {
        "data-cy": "status",
        name: "status",
        component: SearchSelect,
        options: translation ? translation.selects.status.items : selects.invoice_status,
        className: [classes.mr15, classes.w40].join(" "),
        variant: "outlined",
        value: values.status
      }), values.status === "paid" && /*#__PURE__*/React.createElement(Field, {
        "data-cy": "payment_date",
        name: "payment_date",
        className: [classes.mr15, classes.w30].join(" "),
        label: translation ? translation.inputs.date : "Date",
        component: DatePicker,
        value: values.payment_date
      }), /*#__PURE__*/React.createElement(Button, {
        className: classes.w20,
        "data-cy": "submit",
        size: "medium",
        color: "primary",
        variant: "outlined",
        disabled: !isValid || isSubmitting,
        component: SubmitButton,
        type: "submit"
      }, translation ? translation.buttons.save : "Save")));
    }
  })), /*#__PURE__*/React.createElement(Divider, null), !franchise && /*#__PURE__*/React.createElement(Grid, {
    item: true,
    md: 12,
    className: classes.p50
  }, /*#__PURE__*/React.createElement("div", {
    className: classes.flex
  }, /*#__PURE__*/React.createElement(Typography, {
    variant: "subtitle1",
    color: "primary"
  }, translation ? translation.send : "Notification"), /*#__PURE__*/React.createElement("div", null, selectedInvoice && /*#__PURE__*/React.createElement(Chip, {
    variant: "outlined",
    label: selectedInvoice.sent ? "Sent" : "Not sent",
    style: !selectedInvoice.sent ? {
      borderRadius: "5px",
      borderColor: "#999",
      color: "#fff"
    } : {
      borderRadius: "5px",
      borderColor: "#77ffb5",
      color: "#77ffb5"
    }
  }), /*#__PURE__*/React.createElement(Button, {
    "data-cy": "send-notification",
    className: classes.edit,
    color: "default",
    variant: "text",
    onClick: handleSendNotification
  }, /*#__PURE__*/React.createElement(SendIcon, null))))))))];
};

export { DialogViewInvoice };